var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center space-x-2"},_vm._l((_vm.pills),function(pill){return _c('ActivixPill',{key:pill.name,attrs:{"is-active":_vm.activePill === pill.name,"is-disabled":pill.disabled,"label":pill.label},on:{"click":function($event){return _vm.onClick(pill)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }